<template>
  <div id="app">
    <loading-overlay :active="isLoading" :loader="loader" />
    <router-view />
    <notifications-list />
  </div>
</template>
<style>
#app {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden !important;
}
</style>
<script>
import { mapGetters } from "vuex";
import NotificationsList from "./components/core/NotificationsList.vue";

export default {
  name: "app",
  components: {
    NotificationsList,
  },
  data() {
    return {
      loader: "bars",
    };
  },
  computed: {
    ...mapGetters(["isLoading"]),
  },
  created() {
    let self = this;

    // this.$store.dispatch("getUser").then(function(){
    //     self.$store.dispatch("getUserAccessDetails");
    // });
  },
  mounted() {
    this.$store.commit("PUSH_NOTIFICATION", {});
  },
};
</script>
